import EmblaCarousel from 'embla-carousel';

export function initTreatmentsSlider() {
    const sliderElement = document.querySelector('.js-treatments-slider');

    if (!sliderElement) return;

    const viewport = sliderElement.querySelector('.embla__viewport');
    const dotsContainer = document.querySelector('.embla-treatmentblock-pagination');
    const prevBtn = document.querySelector('.c_swiper-treatmentblock-prev');
    const nextBtn = document.querySelector('.c_swiper-treatmentblock-next');

    let embla = null;

    function buildDots() {
        if (!dotsContainer || !embla) return;
        dotsContainer.innerHTML = '';
        embla.scrollSnapList().forEach((_, i) => {
            const dot = document.createElement('button');
            dot.className = 'swiper-pagination-bullet';
            dot.type = 'button';
            dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
            dot.addEventListener('click', () => embla.scrollTo(i));
            dotsContainer.appendChild(dot);
        });
        updateDots();
    }

    function updateDots() {
        if (!dotsContainer || !embla) return;
        const index = embla.selectedScrollSnap();
        dotsContainer.querySelectorAll('.swiper-pagination-bullet').forEach((dot, i) => {
            dot.classList.toggle('swiper-pagination-bullet-active', i === index);
        });
    }

    function initEmbla() {
        if (window.innerWidth < 768 && !embla) {
            embla = EmblaCarousel(viewport, {
                align: 'start',
                slidesToScroll: 1,
                loop: false,
                dragFree: false,
            });

            buildDots();
            embla.on('select', updateDots);

            if (prevBtn) prevBtn.addEventListener('click', () => embla.scrollPrev());
            if (nextBtn) nextBtn.addEventListener('click', () => embla.scrollNext());
        } else if (window.innerWidth >= 768 && embla) {
            embla.destroy();
            embla = null;
            if (dotsContainer) dotsContainer.innerHTML = '';
        }
    }

    initEmbla();
    window.addEventListener('resize', initEmbla);
}
